import { render, staticRenderFns } from "./PointFilterDepositLayout.vue?vue&type=template&id=2f1d1bee&"
import script from "./PointFilterDepositLayout.vue?vue&type=script&lang=js&"
export * from "./PointFilterDepositLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports